// extracted by mini-css-extract-plugin
export default {"link":"ContentNavigator_link__gGpOj"};